import { render, staticRenderFns } from "./ModalRealizarAvaliacao.vue?vue&type=template&id=2b5c8674&scoped=true"
import script from "./ModalRealizarAvaliacao.vue?vue&type=script&lang=ts"
export * from "./ModalRealizarAvaliacao.vue?vue&type=script&lang=ts"
import style0 from "./ModalRealizarAvaliacao.vue?vue&type=style&index=0&id=2b5c8674&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5c8674",
  null
  
)

export default component.exports